import { GenericElementEvent } from '../../../../../services/event/event/generic-element-event';

export class GenericGridInitEvent extends GenericElementEvent {
    
}
